module.exports = __webpack_public_path__ + "static/media/disconnected.13930747.wav";